import React from "react";
import { Link } from "react-router-dom";
import i18n from "../../i18n";
import { baseUrl } from "../../constants/global";
import swal from "sweetalert";
import { loginUser } from "../../models/login";
import { withRouter } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

export const NewLogin = () => {
    const navigate = useNavigate();
    return <NewLoginClassComponent navigate={navigate} />;
};


class NewLoginClassComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            login: '',
            password: '',
            rememberMe: false,
            isLoading: false,
            showPassword: false,
            errors: {}
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState({
            [name]: type === 'checkbox' ? checked : value,
            errors: { ...this.state.errors, [name]: '' }
        });
    }

    togglePasswordVisibility = () => {
        this.setState(prevState => ({
            showPassword: !prevState.showPassword
        }));
    }

    validateForm = () => {
        const { login, password } = this.state;
        const errors = {};

        // login / Email validation
        if (!login?.trim()) {
            errors.login = i18n.t("email_is_required");
        }

        // Password validation
        if (!password) {
            errors.password = i18n.t("password_is_required");
        }

        this.setState({ errors });
        return Object.keys(errors).length === 0;
    };


    handleSubmit = async (e) => {
        e.preventDefault();

        if (!this.validateForm()) return;

        this.setState({ isLoading: true });

        try {
            const response = await loginUser({
                login: this.state.login,
                password: this.state.password,
            });

            if (response?.data?.requires_verification) {
                localStorage.setItem('verification_pending', JSON.stringify(response.data));

            this.props.navigate(`/verify-otp/${response?.data?.verification_token}`, { state: response.data });

            }
            else if (response?.data?.token) {
                swal(i18n.t("success"), i18n.t("login_message"), "success", {
                    buttons: false,
                    timer: 2000,
                }).then(() => {
                    localStorage.setItem("is_logged_in", true);
                    localStorage.setItem("token", response.data.token);
                    localStorage.setItem("mzad_user_info", JSON.stringify(response.data.user));
                    window.location.href = response.data.user.role === "A" ? "/dashboard" : "/";
                });
            }
            else {
                swal("Failed", response?.message || "Login failed", "error");
            }
        } catch (err) {
            swal("Failed", err.message || "Something went wrong", "error");
        } finally {
            this.setState({ isLoading: false });
        }
    };

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSubmit(e);
        }
    };

    render() {
        const { login, password, rememberMe, isLoading, showPassword, errors } = this.state;

        return (
            <div className="vh-100 d-flex">
                {/* Left Side - Login Form */}
                <div className="col-lg-6 d-flex align-items-center justify-content-center bg-white">
                    <div className="w-100" style={{ maxWidth: '400px', padding: '2rem' }}>

                        {/* Welcome Header */}
                        <div className="mb-3">
                            <h2 className="fw-bold text-dark mb-2" style={{ fontSize: '2rem' }}>
                                {i18n.t("login")}
                            </h2>
                        </div>

                        {/* Login Form */}
                        <form onSubmit={this.handleSubmit}>
                            {/* Email Field */}
                            <div className="mb-3">
                                <label className="form-label text-dark fw-medium mb-1">
                                    {i18n.t("username_or_email")}
                                </label>
                                <input
                                    type="text"
                                    name="login"
                                    className={`form-control ${errors.login ? 'is-invalid' : ''}`}
                                    value={login}
                                    onChange={this.handleInputChange}
                                    onKeyPress={this.handleKeyPress}
                                    style={{
                                        padding: '12px 16px',
                                        fontSize: '14px',
                                        border: errors.email ? '1px solid #dc3545' : '1px solid #d1d5db',
                                        borderRadius: '8px',
                                        backgroundColor: '#fff'
                                    }}
                                    placeholder={i18n.t("username_or_email")}
                                />
                                {errors.login && (
                                    <div className="text-danger small mt-1">{errors.login}</div>
                                )}
                            </div>

                            {/* Password Field with Eye Toggle */}
                            <div className="mb-2">
                                <label className="form-label text-dark fw-medium mb-1">
                                    {i18n.t("password")}
                                </label>
                                <div className="position-relative">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                        value={password}
                                        onChange={this.handleInputChange}
                                        onKeyPress={this.handleKeyPress}
                                        style={{
                                            padding: '12px 16px',
                                            paddingRight: '45px',
                                            fontSize: '14px',
                                            border: errors.password ? '1px solid #dc3545' : '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            backgroundColor: '#fff'
                                        }}
                                        placeholder={i18n.t("please_enter_password")}
                                    />
                                    <button
                                        type="button"
                                        onClick={this.togglePasswordVisibility}
                                        className="btn btn-link position-absolute"
                                        style={{
                                            right: '8px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            padding: '4px 8px',
                                            color: '#6b7280',
                                            textDecoration: 'none',
                                            border: 'none',
                                            background: 'transparent'
                                        }}
                                        tabIndex="-1"
                                    >
                                        <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                    </button>
                                </div>
                                {errors.password && (
                                    <div className="text-danger small mt-1">{errors.password}</div>
                                )}
                            </div>

                            {/* Remember Me & Forgot Password */}
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <Link
                                    to="/forgot-password"
                                    className="text-decoration-none fw-medium"
                                    style={{ color: '#189397', fontSize: '14px' }}
                                >
                                    {i18n.t("forget_password")}
                                </Link>
                            </div>

                            {/* Sign In Button */}
                            <button
                                type="submit"
                                disabled={isLoading}
                                className="btn w-100 text-white fw-medium mb-2"
                                style={{
                                    backgroundColor: '#189397',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    fontSize: '14px'
                                }}
                            >
                                {isLoading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Signing in...
                                    </>
                                ) : (
                                    i18n.t("login")
                                )}
                            </button>
                        </form>

                        {/* OTP Login Button */}
                        <Link
                            to="/login_otp"
                            className="btn w-100 fw-medium mb-3"
                            style={{
                                border: '#d1d5db 1px solid',
                                color: 'black',
                                borderRadius: '8px',
                                fontSize: '14px'
                            }}
                        >
                            <span style={{ color: 'black' }}>
                                {i18n.t("login_using_otp")}
                            </span>
                        </Link>

                        {/* Sign Up Link */}
                        <div className="text-center mb-3">
                            <span className="text-muted" >
                                {i18n.t("donthaveaccount")}  <Link
                                    to="/register"
                                    style={{ color: '#189397', fontSize: '15px' }}
                                > {i18n.t("register_bidder")}</Link>
                            </span>
                        </div>
                    </div>
                </div>

                <div
                    className="col-lg-6 d-none d-lg-block position-relative"
                    style={{
                        backgroundImage: `linear-gradient(135deg, rgba(24,147,151,0.5) 0%, rgba(189,197,50,0.5) 100%),url('/assets/images/auth/banner-1.jpeg')`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }}
                >
                </div>

                {/* FontAwesome CDN */}
                <link
                    rel="stylesheet"
                    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
                />
            </div>
        );
    }
}
export default NewLogin;
